import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm,SubmitHandler } from 'react-hook-form';
//import Redis from './RedisCl';
import './Signin.css';

function Signin() {
    const navigate = useNavigate();
   
    const {
        register,
        handleSubmit,
        watch,
        formState:{errors},
    } = useForm();

    const onSubmit = (data) => {
        console.log("teamNumber",data.teamNumber);
        console.log("userID",data.userID);
        //console.log("data",redisClient.get(data.id));

        fetch('https://night.eng.tamagawa.ac.jp/yjs/api/login',{
            method:'POST',
            headers:{
                'Content-Type': 'application/json'
            },
            body:JSON.stringify(data)
        })
        .then(response => {
            if (response.status === 200) {
                navigate('/Top',{state:{teamNumber:data.teamNumber , userID:data.userID}});
                return response.json();
                
            } else if (response.status === 401) {
                return Promise.reject(new Error('Login failed'));
            } else {
                return Promise.reject(new Error('Internal server error'));
            }
        })
        .then(data => {
            console.log(data.message); 
        })
        .catch(error => {
            console.error(error.message); 
        });
        
    }

  return (
    <div>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className='formField'>
                <input
                    id = "teamNumber"
                    type='number'
                    placeholder='teamNumber'
                    {...register('teamNumber')}
                />
            </div>
            <div className='formField'>
                <input 
                    id = "userID"
                    type='number'
                    placeholder='userID'
                    {...register('userID')}
                />
            </div>
            <div className='loginButton'>
                <button
                    type='submit'
                    className='submitButton'
                    >ログイン
                </button>
            </div>
        </form>
    </div>
    
  );
}

export default Signin;
